import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import {  ArrowBack as ArrowBackIcon } from "@mui/icons-material";

const PaymentConfirmationModal = ({ open, onClose, orderId }) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  //eslint-disable-next-line 
  const [errors, setErrors] = useState({});
  const [whatsAppUrl, setWhatsAppUrl] = useState("");
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    depositorName: "",
    amountPaid: "",
    phoneNumber: "",
    bankPaidFrom: "",
    paidFromAccountNumber: "",
    date: "",
  });


  

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setSubmitting(true);
  
    try {
      setIsSubmitted(false);
      const token = localStorage.getItem("token");
      const customerId = sessionStorage.getItem("userId");
      const customerEmail = sessionStorage.getItem("userEmail");
  
      // Convert date to ISO 8601 format
      const formattedDate = formData.date ? new Date(formData.date).toISOString() : new Date().toISOString();
  
      const requestBody = {
        customerId: Number(customerId) || 0,
        customerEmail: customerEmail || "",
        phoneNumber: formData.phoneNumber,
        paidFromBankName: formData.bankPaidFrom || "Unknown Bank",
        paidFromAccountNumber: formData.paidFromAccountNumber || "N/A",
        paidDate: formattedDate,
        amountPaid: Number(formData.amountPaid) || 0,
        paidIntoAccountNumber: formData.paidIntoAccountNumber || "N/A",
        orderId: Number(orderId) || 0,
      };
  
      console.log("Request Body:", requestBody);
  
      const response = await fetch(
        "https://daradservice.azurewebsites.net/api/P2PProducts/save-PaymentProof",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "text/plain",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
  
      const result = await response.json();
      console.log("Response from API:", result);
  
      if (!response.ok) {
        throw new Error(result.message || "Failed to submit payment details");
      }
  
      setSuccessMessage(result.message || "Payment details submitted successfully!");
      setWhatsAppUrl(result.data?.whatsAppUrl || "");
      setSubmitting(false);
  
      // Delay setting isSubmitted to allow success message to be displayed
      setTimeout(() => {
        setIsSubmitted(true);
      }, 2000); // 2 seconds delay before navigating
  
    } catch (error) {
      console.error("Error submitting payment details:", error);
      setSubmitting(false);
    }
  };
  
  useEffect(() => {
    if (successMessage && isSubmitted) {
      onClose();
  
      if (whatsAppUrl) {
        try {
          const cleanUrl = encodeURI(whatsAppUrl.trim());
  
          if (cleanUrl.startsWith("https://wa.me") || cleanUrl.startsWith("https://api.whatsapp.com")) {
            window.location.href = cleanUrl;
          } else {
            console.error("Invalid WhatsApp URL:", cleanUrl);
          }
        } catch (error) {
          console.error("Error processing WhatsApp URL:", error);
          alert("Unable to process WhatsApp URL.");
        }
      } else {
        console.warn("No WhatsApp URL provided.");
      }
    }
  }, [successMessage, whatsAppUrl, onClose, isSubmitted]);
  

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isDesktop ? 800 : "90%",
          bgcolor: "#fff",
          p: isDesktop ? 4 : 3,
          borderRadius: 2,
          boxShadow: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%", display: "flex", alignItems: "center", mb: 2 }}>
          <IconButton
            onClick={onClose}
            sx={{
              color: "white",
              background: "#5604F6",
              fontSize: "48px",
              borderRadius: "50%",
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography sx={{ flex: 1, textAlign: "center", fontSize: isDesktop ? "28px" : "20px", color: "#5604F6" }}>
            Payment Details
          </Typography>
        </Box>

        <Typography sx={{ fontSize: "16px", color: "#000", mb: 2, textAlign: "center" }}>
          To confirm your payment, fill in all the details below.
        </Typography>


        {successMessage && (
          <Typography sx={{ color: "green", fontSize:"24px" , fontFamily: "Urbanist",fontWeight:"600", mb: 2, textAlign: "center" }}>{successMessage}</Typography>
        )}
        <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    width: "100%",
  }}
>
  {/* Depositor Name and Phone Number */}
  <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
    <TextField
      name="depositorName"
      label="Depositor Name"
      fullWidth
      sx={{ mt: 1 }}
      onChange={handleInputChange}
    />
    <TextField
      name="phoneNumber"
      label="Phone Number"
      fullWidth
      sx={{ mt: 1 }}
      onChange={handleInputChange}
    />
  </Box>

  {/* Amount Paid and Bank Paid From */}
  <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
    <TextField
      name="amountPaid"
      label="Amount Paid"
      fullWidth
      sx={{ mt: 1 }}
      onChange={handleInputChange}
    />
    <TextField
      name="bankPaidFrom"
      label="Bank Paid From"
      fullWidth
      sx={{ mt: 1 }}
      onChange={handleInputChange}
    />
  </Box>

  {/* Paid From Account Number and Date */}
  <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
    <TextField
      name="paidFromAccountNumber"
      label="Paid From Account Number"
      fullWidth
      sx={{ mt: 1 }}
      onChange={handleInputChange}
    />
    <TextField
      name="date"
      label="Date"
      type="date"
      fullWidth
      sx={{ mt: 1 }}
      InputLabelProps={{ shrink: true }}
      onChange={handleInputChange}
    />
  </Box>
</Box>

        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mt: 3 }}>
          <Button
            sx={{
              width: "100%",
              maxWidth: "300px",
              padding: "10px 20px",
              borderRadius: "25px",
              backgroundColor: "#5604F6 !important",
              color: "#EEE6FE !important",
              fontSize: "18px",
              textAlign: "center",
            }}
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Submit"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PaymentConfirmationModal;
